/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DigitalWalletKeyVersionDto } from '../models/digital-wallet-key-version-dto';

@Injectable({
  providedIn: 'root',
})
export class ApplePaymentProcessingCertificateService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation applePaymentProcessingCertificateGetCsr
   */
  static readonly ApplePaymentProcessingCertificateGetCsrPath = '/v1/admin/apple-payment-processing-certificate/get-csr';

  /**
   * Returns generated CSR for apple developer panel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `applePaymentProcessingCertificateGetCsr()` instead.
   *
   * This method doesn't expect any request body.
   */
  applePaymentProcessingCertificateGetCsr$Response(params?: {
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ApplePaymentProcessingCertificateService.ApplePaymentProcessingCertificateGetCsrPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Returns generated CSR for apple developer panel.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `applePaymentProcessingCertificateGetCsr$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  applePaymentProcessingCertificateGetCsr(params?: {
  }): Observable<Blob> {

    return this.applePaymentProcessingCertificateGetCsr$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation applePaymentProcessingCertificateUploadCertificate
   */
  static readonly ApplePaymentProcessingCertificateUploadCertificatePath = '/v1/admin/apple-payment-processing-certificate/upload-certificate';

  /**
   * Uploads payment processing certificate generated by Apple on CSR.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `applePaymentProcessingCertificateUploadCertificate()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  applePaymentProcessingCertificateUploadCertificate$Response(params?: {
    body?: {
'pkcsFile'?: Blob | null;
}
  }): Observable<StrictHttpResponse<DigitalWalletKeyVersionDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApplePaymentProcessingCertificateService.ApplePaymentProcessingCertificateUploadCertificatePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DigitalWalletKeyVersionDto>;
      })
    );
  }

  /**
   * Uploads payment processing certificate generated by Apple on CSR.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `applePaymentProcessingCertificateUploadCertificate$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  applePaymentProcessingCertificateUploadCertificate(params?: {
    body?: {
'pkcsFile'?: Blob | null;
}
  }): Observable<DigitalWalletKeyVersionDto> {

    return this.applePaymentProcessingCertificateUploadCertificate$Response(params).pipe(
      map((r: StrictHttpResponse<DigitalWalletKeyVersionDto>) => r.body as DigitalWalletKeyVersionDto)
    );
  }

  /**
   * Path part for operation applePaymentProcessingCertificateRevoke
   */
  static readonly ApplePaymentProcessingCertificateRevokePath = '/v1/admin/apple-payment-processing-certificate/{token}/revoke';

  /**
   * Revokes payment processing certificate by token identifier.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `applePaymentProcessingCertificateRevoke()` instead.
   *
   * This method doesn't expect any request body.
   */
  applePaymentProcessingCertificateRevoke$Response(params: {

    /**
     * Certificate&#x27;s token identifier
     */
    token: string;
  }): Observable<StrictHttpResponse<DigitalWalletKeyVersionDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApplePaymentProcessingCertificateService.ApplePaymentProcessingCertificateRevokePath, 'post');
    if (params) {
      rb.path('token', params.token, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DigitalWalletKeyVersionDto>;
      })
    );
  }

  /**
   * Revokes payment processing certificate by token identifier.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `applePaymentProcessingCertificateRevoke$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  applePaymentProcessingCertificateRevoke(params: {

    /**
     * Certificate&#x27;s token identifier
     */
    token: string;
  }): Observable<DigitalWalletKeyVersionDto> {

    return this.applePaymentProcessingCertificateRevoke$Response(params).pipe(
      map((r: StrictHttpResponse<DigitalWalletKeyVersionDto>) => r.body as DigitalWalletKeyVersionDto)
    );
  }

  /**
   * Path part for operation applePaymentProcessingCertificateSetOrderAsPrimary
   */
  static readonly ApplePaymentProcessingCertificateSetOrderAsPrimaryPath = '/v1/admin/apple-payment-processing-certificate/{token}/set-order-as-primary';

  /**
   * Set certificate as primary by certificate token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `applePaymentProcessingCertificateSetOrderAsPrimary()` instead.
   *
   * This method doesn't expect any request body.
   */
  applePaymentProcessingCertificateSetOrderAsPrimary$Response(params: {

    /**
     * Certificate&#x27;s token identifier
     */
    token: string;
  }): Observable<StrictHttpResponse<DigitalWalletKeyVersionDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApplePaymentProcessingCertificateService.ApplePaymentProcessingCertificateSetOrderAsPrimaryPath, 'post');
    if (params) {
      rb.path('token', params.token, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DigitalWalletKeyVersionDto>;
      })
    );
  }

  /**
   * Set certificate as primary by certificate token.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `applePaymentProcessingCertificateSetOrderAsPrimary$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  applePaymentProcessingCertificateSetOrderAsPrimary(params: {

    /**
     * Certificate&#x27;s token identifier
     */
    token: string;
  }): Observable<DigitalWalletKeyVersionDto> {

    return this.applePaymentProcessingCertificateSetOrderAsPrimary$Response(params).pipe(
      map((r: StrictHttpResponse<DigitalWalletKeyVersionDto>) => r.body as DigitalWalletKeyVersionDto)
    );
  }

  /**
   * Path part for operation applePaymentProcessingCertificateGetCertificates
   */
  static readonly ApplePaymentProcessingCertificateGetCertificatesPath = '/v1/admin/apple-payment-processing-certificate/get-certificates';

  /**
   * Returns list of the last 3 payment processing certificates.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `applePaymentProcessingCertificateGetCertificates()` instead.
   *
   * This method doesn't expect any request body.
   */
  applePaymentProcessingCertificateGetCertificates$Response(params?: {
  }): Observable<StrictHttpResponse<Array<DigitalWalletKeyVersionDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ApplePaymentProcessingCertificateService.ApplePaymentProcessingCertificateGetCertificatesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DigitalWalletKeyVersionDto>>;
      })
    );
  }

  /**
   * Returns list of the last 3 payment processing certificates.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `applePaymentProcessingCertificateGetCertificates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  applePaymentProcessingCertificateGetCertificates(params?: {
  }): Observable<Array<DigitalWalletKeyVersionDto>> {

    return this.applePaymentProcessingCertificateGetCertificates$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DigitalWalletKeyVersionDto>>) => r.body as Array<DigitalWalletKeyVersionDto>)
    );
  }

}
